"use client";

import { useMediaQuery } from "@/hooks/useMediaQuery";

/**
 * Phones and tablets: no hover, a coarse primary pointer. Mirrors the
 * `touch-device` custom variant in app/globals.css; change both together.
 */
export const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

/**
 * False on the server and on the first client render, so markup that depends
 * on it should either mount after a user action or use the same query as a
 * CSS media variant to avoid a post-hydration swap.
 */
export function useIsTouch(): boolean {
  return useMediaQuery(TOUCH_QUERY, false);
}
